import React, { useState, useEffect } from "react";
import { Modal, Form, Button, Dropdown, DropdownButton } from "react-bootstrap";
import { getNextId } from "../../../../../localDB";
import './OpalCreateReminder.css';
import TauriLoader2 from "../../../../TauriLoader2/TauriLoader2";
import { SyncStatusMap } from "../../../../../visualizations/visualizations";

const OpalCreateReminder = ({ show, onHide, sessionId, onSave, isCreating }) => {
    const today = new Date();


    const [newNote, setNewNote] = useState({
        ID: null,
        Content: '',
        ContentType: 2,
        SessionID: null,
        ReminderDate: today.toISOString().split("T")[0],
        ReminderTime: today.toISOString().split("T")[1],
        CreatedDate: today.toISOString(),
        ReminderLocation: ''
    });

    const [errors, setErrors] = useState({});

    const validate = () => {
        const validationErrors = {};
        if (!newNote.Content.trim()) {
            validationErrors.Content = "Content is required.";
        }
        if (!newNote.ReminderDate.trim()) {
            validationErrors.ReminderDate = "Reminder Date is required.";
        }
        if (!newNote.ReminderLocation.trim()) {
            validationErrors.ReminderLocation = "Reminder Location is required.";
        }
        return validationErrors;
    };

    const handleSave = async () => {
        const validationErrors = validate();
        if (Object.keys(validationErrors).length > 0) {
            setErrors(validationErrors);
            return;
        }

        const id = await getNextId("sessionNotes");

        const newNoteToSave = {
            ID: id,
            Content: newNote.Content,
            ContentType: 2,
            ReminderDate: newNote.ReminderDate ? newNote.ReminderDate : today.toISOString().split("T")[0],
            ReminderTime: newNote.ReminderTime ? newNote.ReminderTime : today.toISOString().split("T")[1],
            ReminderLocation: newNote.ReminderLocation,
            CreatedDate: today.toISOString(),
            SessionID: sessionId,
            SyncStatus: SyncStatusMap.create
        };

        onSave(newNoteToSave);
        clearNotes();
    };

    const clearNotes = () => {
        setNewNote({
            ID: null,
            Content: '',
            ContentType: 2,
            SessionID: null,
            ReminderDate: today.toISOString().split("T")[0],
            ReminderTime: today.toISOString().split("T")[1],
            CreatedDate: today.toISOString(),
            ReminderLocation: ''
        });
        setErrors({});
    };

    useEffect(() => {
        clearNotes();
    }, [sessionId]);

    return (
        <Modal className="opal-create-reminder" show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title>Add Reminder</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Group className="mb-3">
                        <Form.Label>Content</Form.Label>
                        <Form.Control
                            as="textarea"
                            rows={3}
                            value={newNote.Content}
                            isInvalid={!!errors.Content}
                            onChange={(e) => {
                                setNewNote({ ...newNote, Content: e.target.value });
                                if (errors.Content) {
                                    setErrors({ ...errors, Content: null });
                                }
                            }}
                        />
                        <Form.Control.Feedback type="invalid">
                            {errors.Content}
                        </Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Reminder Date</Form.Label>
                        <Form.Control
                            type="date"
                            value={newNote.ReminderDate}
                            isInvalid={!!errors.ReminderDate}
                            onChange={(e) => {
                                setNewNote({ ...newNote, ReminderDate: e.target.value });
                                if (errors.ReminderDate) {
                                    setErrors({ ...errors, ReminderDate: null });
                                }
                            }}
                        />
                    </Form.Group>
                    <Form.Group className="mb-3">
                        <Form.Label>Reminder Location</Form.Label>
                        <Form.Control
                            type="text"
                            value={newNote.ReminderLocation}
                            isInvalid={!!errors.ReminderLocation}
                            onChange={(e) => {
                                setNewNote({ ...newNote, ReminderLocation: e.target.value });
                                if (errors.ReminderLocation) {
                                    setErrors({ ...errors, ReminderLocation: null });
                                }
                            }}
                        />
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button className="opal-reminder-confirm" onClick={handleSave} disabled={isCreating}>
                    {isCreating && (
                        <TauriLoader2 width="1.2rem" height="1.2rem" borderwidth="0.2rem" color="#000" />
                    )}
                    <span className="ms-2 text-nowrap">Save</span>
                </Button>
                <Button className="opal-reminder-close" onClick={onHide}>
                    Cancel
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export default OpalCreateReminder;
